export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-300">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="flex-1 max-w-sm">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-base"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50">豆花视频</span>
            </div>
            <p className="text-sm leading-relaxed text-background-400 font-body">
              豆花视频汇集西瓜视频、芒果视频、丝瓜视频等优质影视资源，免费高清不缓冲，电视剧全集电影大全随时在线观看，每日更新最新剧集。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-background-100 mb-4">快速导航</h3>
            <nav className="flex flex-col gap-2">
              {[
                { label: '精彩推荐', href: '#media' },
                { label: '热门榜单', href: '#ranking' },
                { label: '话题广场', href: '#topics' },
                { label: '常见问题', href: '#faq' },
                { label: '关于豆花', href: '#about' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector(item.href);
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-background-100 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500 font-body">优质平台持续加入中</p>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-background-100 mb-4">联系方式</h3>
            <p className="text-sm text-background-400 font-body">投稿与合作请通过页内联系入口</p>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#contact');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-1.5 mt-2 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              联系我们
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500 font-body">
            &copy; {new Date().getFullYear()} 豆花视频 - 免费在线观看影视平台
          </p>
          <p className="text-xs text-background-600 font-body">
            本站为影视资源聚合导航，内容源自公开网络
          </p>
        </div>
      </div>
    </footer>
  );
}